import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useStatusField } from 'data/fields/hooks';
import { ProgressStatusBar, getProgress } from '../projects/progress-status';
import { PopoverContent } from '../projects/progress-status/popover';

export const ProjectProgress = ({ data }) => {
  const progress = getProgress(data.progressStatus);

  const statusField = useStatusField();

  return (
    <div>
      <ProgressStatusBar
        progressStatuses={data.progressStatus}
        subTitle={data.projectName}
        showPopover={false}
        title={<FormattedMessage id="projects.list.progress" />}
      />
      {PopoverContent(progress, statusField)}
    </div>
  );
};
